/****************************************************
 * Module Name:  stockSearchCriteria.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Box, Button, Checkbox, FormControlLabel, Tooltip, TextField, Tabs, Tab } from "@mui/material";

import Select from "react-select";

import CutProxy from "../../utility/proxy/manager/cutProxy";
import FloProxy from "../../utility/proxy/manager/floProxy";
import ShapeProxy from "../../utility/proxy/manager/shapeProxy";
import PolProxy from "../../utility/proxy/manager/polProxy";
import ColorProxy from "../../utility/proxy/manager/colorProxy";
import ClarityProxy from "../../utility/proxy/manager/clarityProxy";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import SymProxy from "../../utility/proxy/manager/symProxy";
import LabProxy from "../../utility/proxy/manager/labProxy";
import UserProxy from "../../utility/proxy/manager/userProxy";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import SizeProxy from "../../utility/proxy/manager/sizeProxy";

import Constants from "../../utility/constants";
import Utility from "../../utility/utility";

import CommonSnackbar from "../common/commonSnackBar";

import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SaveIcon from '@mui/icons-material/Save';
import SaveAsIcon from "@mui/icons-material/SaveAs";
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SavedsearchhistoryProxy from "../../utility/proxy/manager/savedsearchhistoryProxy";
import StoneTypeProxy from "../../utility/proxy/manager/stoneTypeProxy";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "./userDetailModal";

export default class StockSearchCriteria extends Component {
  constructor(props) {
    super(props)
    if (props.stockCriteriaStored === '') {
      this.state = {
        customerOption: [],
        selectedCustomer: this.defaultOption,
        customerLoadSpinner: Constants.loggedInUser.usertype !== 'C',

        savedSearch: true,
        savedSearchOption: [],
        selectedSavedSearch: this.defaultOption,
        savedSearchCriteria: {},

        previousSearchOption: [],
        selectedPreviousSearch: this.defaultOption,

        showMoreShapeOption: true,
        showAllShape: false,
        shapeOption: [],
        selectedShape: [],

        weightSpecific: true,
        weightOption: [],
        weightFrom: '',
        weightTo: '',
        weightToError: '',
        generalWeightDossiers: false,
        generalWeightCarat: false,
        generalSelectedWeight: [],

        colorWhite: true,
        colorOption: [],
        intensityOption: this.getIntensityOption(),
        selectedFromIntensity: '',
        selectedToIntensity: '',
        overtoneOption: this.getOvertoneOption(),
        selectedOvertone: '',
        fancyColorOption: this.getFancycolorOption(),
        selectedFancyColor1: '',
        selectedFancyColor2: '',

        cutOption: [],
        polOption: [],
        symOption: [],
        floOption: [],
        cpsOption: this.getCPSOption(),

        labOption: [],
        locationOption: [],

        bgmOption: this.getBGMOption(),
        blackOption: this.getBlackOption(),

        clarityOption: [],

        depthFrom: '',
        depthTo: '',

        tableFrom: '',
        tableTo: '',
        tableFromToError: '',
        ratioFrom: '',
        ratioTo: '',
        ratioFromToError: '',
        lengthFrom: '',
        lengthTo: '',
        lengthFromToError: '',
        widthFrom: '',
        widthTo: '',
        widthFromToError: '',
        priceFrom: '',
        priceTo: '',
        priceFromToError: '',
        totalFrom: '',
        totalTo: '',
        totalFromToError: '',

        showAdvanceOption: false,

        disabledSearch: false,
        showSuccessSave: false,
        showSaveAsModal: false,
        saveAsSearchName: '',
        saveAsLoading: false,

        stoneIds: '',
        showUserDetailModal: false,
        userIds: [],

        tabValue: 0,
        activeTab: this.checkPermission("STONETYPE_NATURAL") || !this.checkPermission("STONETYPE_LABGROWN") ? "Natural" : "Lab Grown",
        stonetypeOption: [],
        showNaturalTab: this.checkPermission("STONETYPE_NATURAL") || !this.checkPermission("STONETYPE_LABGROWN"),
        showLabGrownTab: this.checkPermission("STONETYPE_LABGROWN"),
      }

      if (Constants.loggedInUser.usertype !== 'C' && this.props.displaySearchCriteria)
        this.getCustomerData();

      this.getSavedSearchData();
      this.getAllShapeData();
      this.getAllWeightData();
      this.getAllColorData();
      this.getAllClarityData();
      this.getAllCutData();
      this.getAllPolData();
      this.getAllSymData();
      this.getAllFloData();
      this.getAllLabData();
      this.getAllLocationData();

      if (this.state.showLabGrownTab)
        this.getAllStoneType();

    } else {
      this.state = JSON.parse(props.stockCriteriaStored);

      if (this.props.guid) {
        this.state.showNaturalTab = this.checkPermission("STONETYPE_NATURAL") || !this.checkPermission("STONETYPE_LABGROWN");
        this.state.showLabGrownTab = this.checkPermission("STONETYPE_LABGROWN");
        if (this.state.activeTab === "Natural") {
          this.state.stonetypeOption = this.state.stonetypeOption.map(iStoneType => ({ ...iStoneType, selected: false }));
          this.state.activeTab = this.state.showNaturalTab ? this.state.activeTab : (this.state.showLabGrownTab ? "Lab Grown" : "Natural");
        } else {
          this.state.activeTab = this.state.showLabGrownTab ? this.state.activeTab : "Natural";
        }
        this.state.tabValue = this.state.activeTab === "Natural" ? 0 : (this.state.activeTab === "Lab Grown" && this.state.showNaturalTab ? 1 : 0);
        this.state.showCommonSnackbar = true;

        if (this.props.displaySearchCriteria)
          this.getCustomerData();
      }
    }
  }

  checkPermission = (permission) => {
    return Utility.isReadAllowed(Constants.USER_PERMISSION.filter((iPermission) =>
      iPermission.permissionid === Constants.PERMISSIONS[permission]
    ));
  }

  handleTabChange = (event, newValue) => {
    this.setState({
      activeTab: event.target.textContent,
      tabValue: newValue
    }, () => this.getCustomerData());
  };

  defaultOption = { label: 'Select', value: -1 };

  getBGMOption = () => {
    return [
      { value: "NO BGM", label: "NO BGM", selected: false },
      { value: "ONLY MILKY", label: "ONLY MILKY", selected: false },
      { value: "ONLY BROWN", label: "ONLY BROWN", selected: false }
    ];
  }

  getBlackOption = () => {
    return [
      { value: "NO BLACK", label: "NO BLACK", selected: false },
      { value: "SIDE BLACK", label: "SIDE BLACK", selected: false }
    ];
  }

  getCPSOption = () => {
    return [
      { value: 1, label: "3EX", selected: false },
      { value: 2, label: "EX Cut", selected: false },
      { value: 3, label: "3VG+", selected: false },
    ];
  }

  getFancycolorOption = () => {
    return [
      { value: 1, label: "Yellow" },
      { value: 2, label: "Pink" },
      { value: 3, label: "Blue" },
      { value: 4, label: "Red" },
      { value: 5, label: "Green" },
      { value: 6, label: "Purple" },
      { value: 7, label: "Orange" },
      { value: 8, label: "Gray" },
      { value: 9, label: "Black" },
      { value: 10, label: "Brown" },
      { value: 12, label: "Other" },
      { value: 13, label: "White" },
    ];
  }

  getOvertoneOption = () => {
    return [
      { value: 1, label: "Yellow" },
      { value: 2, label: "Yellowish" },
      { value: 3, label: "Pink" },
      { value: 4, label: "Pinkish" },
      { value: 5, label: "Blue" },
      { value: 6, label: "Bluish" },
      { value: 7, label: "Red" },
      { value: 8, label: "Redish" },
      { value: 9, label: "Green" },
      { value: 10, label: "Greenish" },
      { value: 11, label: "Purple" },
      { value: 12, label: "Purplish" },
      { value: 13, label: "Orange" },
      { value: 14, label: "Orangey" },
      { value: 15, label: "Violet" },
      { value: 16, label: "Gray" },
      { value: 17, label: "Grayish" },
      { value: 18, label: "Brown" },
      { value: 19, label: "Brownish" },
      { value: 20, label: "Other" },
      { value: 21, label: "Brown-Greenish" },
    ];
  }

  getIntensityOption = () => {
    return [
      { value: 1, label: "Faint" },
      { value: 2, label: "Very Light" },
      { value: 3, label: "Light" },
      { value: 4, label: "Fancy Light" },
      { value: 5, label: "Fancy" },
      { value: 6, label: "Fancy Dark" },
      { value: 7, label: "Fancy Intense" },
      { value: 8, label: "Fancy Vivid" },
      { value: 9, label: "Fancy Deep" },
      { value: 10, label: "Fancy Brown" }
    ];
  }

  handleShapeSelect = (idx) => {
    let sOption = JSON.parse(JSON.stringify(this.state.shapeOption));
    sOption[idx].selected = !sOption[idx].selected;
    this.setState({
      shapeOption: sOption
    });
  }

  handleSavedSearchChange = (selectedSavedSearchOption) => {
    let { stonetype } = selectedSavedSearchOption.searchdata;
    let tempActiveTab = (!stonetype || stonetype.includes('N')) ? "Natural" : "Lab Grown";

    let searchdata = { ...selectedSavedSearchOption.searchdata, activeTab: tempActiveTab };
    let tempSelectedSavedSearchOption = { ...selectedSavedSearchOption, searchdata: searchdata };

    this.setState({ selectedSavedSearch: tempSelectedSavedSearchOption });
    this.setSelection(tempSelectedSavedSearchOption.searchdata);
  }

  handlePreviousSearchChange = (selectedPreviousSearchOption) => {
    let { weight, generalselectedweight, generalweightcarat, generalweightdossiers } = selectedPreviousSearchOption.searchdata;
    let { color, fancycolor1, fancycolor2, fromintensity, tointensity, overtone } = selectedPreviousSearchOption.searchdata;
    let { stonetype } = selectedPreviousSearchOption.searchdata;

    let tempWeightSpecific = weight.length > 0 ? true : (generalselectedweight.length > 0 || generalweightcarat || generalweightdossiers ? false : true);
    let tempColorWhite = color.length > 0 ? true : (fancycolor1.length > 0 || fancycolor2.length > 0 || overtone.length > 0 || fromintensity || tointensity ? false : true);
    let tempActiveTab = stonetype.includes('N') ? "Natural" : "Lab Grown";

    let searchdata = { ...selectedPreviousSearchOption.searchdata, weightspecific: tempWeightSpecific, colorwhite: tempColorWhite, activeTab: tempActiveTab };

    let tempSelectedPreviousSearchOption = {
      ...selectedPreviousSearchOption,
      searchdata: searchdata
    }

    this.setState({ selectedPreviousSearch: tempSelectedPreviousSearchOption });
    this.setSelection(tempSelectedPreviousSearchOption.searchdata);
  }

  stringToArrayOfString = (str) => {
    str = str.replaceAll("'", "").trim();
    return (str === '') ? [] : str.split(",");
  }

  stringToArrayOfChar = (str) => {
    let tempArrayOfChar = this.stringToArrayOfString(str);
    return tempArrayOfChar.length === 0 ? tempArrayOfChar : tempArrayOfChar.map(char => char.trim());
  };

  stringToArrayOfInteger = (str) => {
    str = str.replaceAll("'", "").trim();
    return (str === '') ? [] : str.split(",").map((iNo) => parseInt(iNo));
  }

  getIdArrayToStringArray = (lOption, lIdArray) => {
    let retArray = [];
    lOption.map((iOpt) => {
      if (lIdArray.includes(iOpt.value))
        retArray.push(iOpt.label);

      return true;
    });

    return retArray;
  }

  getSelectedWeigth = (generalWeight) => {
    let weightOptions = [];

    if (generalWeight.trim() === '')
      return weightOptions;

    let iOpt = JSON.parse(generalWeight);
    iOpt.map((iOMain) => {
      if (!((iOMain[0] === 0.00 && iOMain[1] === 0.99) || (iOMain[0] === 1.00 && iOMain[1] === 100.000))) {
        weightOptions.push({ weightFrom: iOMain[0], weightTo: iOMain[1] });
      }
      return true;
    });

    return weightOptions;
  }

  getSelectedValueArrayFromString = (lOption, strValue) => {
    let retOpt = [];
    let strOpt = this.stringToArrayOfString(strValue);
    lOption.map((iOpt) => {
      if (strOpt.includes(iOpt.label))
        retOpt.push(iOpt.value);

      return true;
    });

    return retOpt;
  }

  convertPreviousToSavedSearchObj = (savedSearch) => {
    let intensity = this.getSelectedValueArrayFromString(this.state.intensityOption, savedSearch.fancycolorintensity);
    let fIn = '', tIn = '';
    intensity.map((iIn) => {
      if (fIn === '' && tIn === '') {
        fIn = iIn;
        tIn = iIn;

        return true;
      }

      if (fIn > iIn)
        fIn = iIn;

      if (tIn < iIn)
        tIn = iIn;

      return true;
    });

    return {
      stoneIds: savedSearch.reportnumber,
      shape: this.getSelectedValueArrayFromString(this.state.shapeOption, savedSearch.shape),
      weight: this.stringToArrayOfInteger(savedSearch.sizemasterid),
      weightfrom: '',
      weightto: '',
      generalweightdossiers: (savedSearch.generalsize.indexOf('[0.00,0.99]') !== -1),
      generalweightcarat: (savedSearch.generalsize.indexOf('[1.00,1000.00]') !== -1),
      generalselectedweight: this.getSelectedWeigth(savedSearch.generalsize),
      color: this.stringToArrayOfString(savedSearch.color),
      fromintensity: fIn,
      tointensity: tIn,
      overtone: this.getSelectedValueArrayFromString(this.state.overtoneOption, savedSearch.fancycolorovertone),
      fancycolor1: this.getSelectedValueArrayFromString(this.state.fancyColorOption, savedSearch.fancycolor1),
      fancycolor2: this.getSelectedValueArrayFromString(this.state.fancyColorOption, savedSearch.fancycolor2),
      clarity: this.stringToArrayOfString(savedSearch.clarity),
      cut: this.stringToArrayOfString(savedSearch.cut),
      pol: this.stringToArrayOfString(savedSearch.pol),
      sym: this.stringToArrayOfString(savedSearch.sym),
      flo: this.stringToArrayOfString(savedSearch.flo),
      lab: this.stringToArrayOfString(savedSearch.lab),
      location: this.stringToArrayOfInteger(savedSearch.locationid),
      bgm: savedSearch.bgm.trim() === '' ? [] : [savedSearch.bgm],
      black: savedSearch.black.trim() === '' ? [] : [savedSearch.black],
      depthfrom: savedSearch.depthfrom,
      depthto: savedSearch.depthto,
      tablefrom: savedSearch.tablefrom,
      tableto: savedSearch.tableto,
      ratiofrom: savedSearch.ratiofrom,
      ratioto: savedSearch.ratioto,
      lengthfrom: savedSearch.lengthfrom,
      lengthto: savedSearch.lengthto,
      widthfrom: savedSearch.widthfrom,
      widthto: savedSearch.widthto,
      pricefrom: savedSearch.cpricefrom,
      priceto: savedSearch.cpriceto,
      totalfrom: savedSearch.tpricefrom,
      totalto: savedSearch.tpriceto,
      stonetype: this.stringToArrayOfChar(savedSearch.stonetype),
    };
  }

  getSavedSearchData = () => {
    StoneProxy.GetSingleUserStockSearchCriteria(Constants.loggedInUser.id, (searchData) => {
      if (searchData) {
        let lSavedSearchCriteria = JSON.parse(searchData.stocksearchcriteria);
        let lSavedSearchOption = [];

        Object.keys(lSavedSearchCriteria).map((iKey) => lSavedSearchOption.push({ value: iKey, label: iKey, searchdata: lSavedSearchCriteria[iKey], selected: false }));

        this.setState({
          savedSearchCriteria: lSavedSearchCriteria,
          savedSearchOption: lSavedSearchOption,
          selectedSavedSearch: this.defaultOption,
        });
      }
    });
  }

  getPreviousSearchData = () => {
    SavedsearchhistoryProxy.getLatestSaveSearchHistory(Constants.loggedInUser.id, (response) => {
      if (!response)
        return;

      let lPreviousSearchOption = [];

      response.map((iPrevSearch, index) => lPreviousSearchOption.push({ value: (index + 1), label: 'Prev Search - ' + (index + 1), searchdata: this.convertPreviousToSavedSearchObj(iPrevSearch) }));

      this.setState({
        previousSearchOption: lPreviousSearchOption,
        selectedPreviousSearch: this.defaultOption,
      });
    });
  }

  getAllStoneType = () => {
    StoneTypeProxy.GetAllStoneTypeByDisabled(false, response => {

      if (response) {
        let stoneTypeOption = [];
        response.map(stonetype => {
          if (stonetype.name !== 'N')
            stoneTypeOption.push({ value: stonetype.name, label: stonetype.fullname, selected: false })

          return true;
        });

        this.setState({
          stonetypeOption: stoneTypeOption,
        });
      }
    })
  }

  getAllLabData = () => {
    LabProxy.GetAllLabMini((response) => {
      let lLabOption = [];
      response.map((data) => lLabOption.push({ value: data.name, label: data.name, selected: false }));

      this.setState({
        labOption: lLabOption
      });
    });
  }

  getAllLocationData = () => {
    LocationProxy.GetAllLocationDetailMini((response) => {
      let lLocationOption = [];
      response.map((data) => lLocationOption.push({ value: data.id, label: data.name, selected: false }));

      this.setState({
        locationOption: lLocationOption
      });
    });
  }

  getAllCutData = () => {
    CutProxy.GetAllCutMini((response) => {
      let lCutOption = [];
      response.map((data) => lCutOption.push({ value: data.name, label: data.name, selected: false }));

      this.setState({
        cutOption: lCutOption
      });
    });
  }

  getAllPolData = () => {
    PolProxy.GetAllPolMini((response) => {
      let lPolOption = [];
      response.map((data) => lPolOption.push({ value: data.name, label: data.name, selected: false }));

      this.setState({
        polOption: lPolOption
      })
    });
  }

  getAllSymData = () => {
    SymProxy.GetAllSymMini((response) => {
      let lSymOption = [];
      response.map((data) => lSymOption.push({ value: data.name, label: data.name, selected: false }));

      this.setState({
        symOption: lSymOption
      });
    });
  }

  getAllFloData = () => {
    FloProxy.GetAllFloMini((response) => {
      let lFloOption = [];
      response.map((data) => lFloOption.push({ value: data.name, label: data.name, selected: false }));

      this.setState({
        floOption: lFloOption
      })
    });
  }

  getAllClarityData = () => {
    ClarityProxy.GetAllClarityMini((response) => {
      let lClarityOption = [];
      response.map((data) => lClarityOption.push({ value: data.name, label: data.name, selected: false }));

      this.setState({
        clarityOption: lClarityOption
      })
    });
  }

  getAllColorData = () => {
    ColorProxy.GetAllColorMini(
      (response) => {
        let lColorOption = [];
        response.map((data) => lColorOption.push({ value: data.name, label: data.name, selected: false }));

        this.setState({
          colorOption: lColorOption,
        });
      });
  }

  getAllWeightData = () => {
    SizeProxy.GetAllSizeMini((response) => {
      let lWeightOption = [];
      response.map((iWeight) => lWeightOption.push({ value: iWeight.id, label: iWeight.name, selected: false }));

      this.setState({
        weightOption: lWeightOption,
      });
    });
  }

  getAllShapeData = () => {
    ShapeProxy.GetAllShapeMini((response) => {
      let res = response.filter((iShape) => iShape.disabled === false);

      let lShapeOption = [];
      res.map((iShape) => lShapeOption.push({ value: iShape.id, label: iShape.name, selected: false, image: iShape.image }));

      this.setState({
        shapeOption: lShapeOption,
        selectedShape: [],
        showMoreShapeOption: (res.length > 18),
        showAllShape: false
      });
    });
  };

  getUsersDetailToUserOptions = (data) => {
    let options = [];
    data.map((iRow) => options.push({ label: iRow.companyname + " | " + iRow.username, value: iRow.id }));

    return options;
  }

  updateCustomerLabel(customer) {
    const updatedLabel = customer.label.split('|')[0].trim();
    return { ...customer, label: updatedLabel };
  }

  getCustomerData = () => {
    let permission = this.state.activeTab === "Natural" ? "STONETYPE_NATURAL" : "STONETYPE_LABGROWN";
    this.setState({});
    if (Constants.loggedInUser.usertype === 'B') {
      UserProxy.GetSpecificBrokerCustomerMiniByPermission(Constants.loggedInUser.id, permission, (response) => {
        if (response === undefined) return;

        let lCustomerOption = this.getUsersDetailToUserOptions(response);
        this.setState({ userIds: lCustomerOption.map(user => user.value) });
        if (this.state.selectedCustomer.value !== -1) {
          let iCustomer = lCustomerOption.find(iCustomer => iCustomer.value === this.state.selectedCustomer.value);
          if (iCustomer) {
            const updatedCustomer = this.updateCustomerLabel(iCustomer);
            this.props.setCustomerId(updatedCustomer);
            this.setState({ selectedCustomer: updatedCustomer });
            if (this.props.guid) {
              setTimeout(() => {
                this.prepareData();
              }, 500);
            }
          } else {
            this.props.setCustomerId("");
            this.setState({ selectedCustomer: this.defaultOption });
          }
        }

        this.setState({
          customerOption: lCustomerOption,
          disabledSearch: true,
          customerLoadSpinner: false
        });
      });
    } else if (Constants.loggedInUser.usertype === 'E') {
      UserProxy.GetSpecificEmployeesCustomerMiniByPermission(Constants.loggedInUser.id, permission, (response) => {
        if (response === undefined) return;

        let lCustomerOption = this.getUsersDetailToUserOptions(response);
        this.setState({ userIds: lCustomerOption.map(user => user.value) });
        this.props.setCustomerOptions(lCustomerOption.map(customer => customer.value));

        if (this.state.selectedCustomer.value !== -1) {
          let iCustomer = lCustomerOption.find(iCustomer => iCustomer.value === this.state.selectedCustomer.value);
          if (iCustomer) {
            const updatedCustomer = this.updateCustomerLabel(iCustomer);
            this.props.setCustomerId(updatedCustomer);
            this.setState({ selectedCustomer: updatedCustomer });
            if (this.props.guid) {
              setTimeout(() => {
                this.prepareData();
              }, 500);
            }
          } else {
            this.props.setCustomerId("");
            this.setState({ selectedCustomer: this.defaultOption });
          }
        }

        this.setState({
          customerOption: lCustomerOption,
          disabledSearch: true,
          customerLoadSpinner: false
        });
      });
    } else {
      if (Constants.loggedInUser.usertype === 'C' && this.state.selectedCustomer.value === Constants.loggedInUser.id) {
        if (this.props.guid) {
          setTimeout(() => {
            this.prepareData();
          }, 500);
        }
      }
    }
  }

  getShapeIcons = () => {
    let optionsToUse = this.state.showAllShape ? this.state.shapeOption : this.state.shapeOption.slice(0, 18);
    return optionsToUse.map((shape, idx) => (
      <button onClick={() => this.handleShapeSelect(idx)}
        style={{ borderRadius: 4, margin: 2, minWidth: '70px', border: 1, borderStyle: 'solid', borderColor: '#ececec', maxWidth: '70px', height: '70px', alignItems: 'center', backgroundColor: shape.selected ? "#DDE2EE" : '#fff', color: '#000' }} >
        <div style={{ transform: "translateY(5px)" }}>
          <div>
            <img className={shape.selected ? "filter-white" : ''} src={`data:image/svg+xml;base64,${shape.image}`} width={30} height={30} alt="" style={{ border: 1, borderColor: "#fff" }} />
          </div>
          <div>
            <p style={{ fontSize: 11, fontWeight: 'bold' }}>{shape.label}</p>
          </div>
        </div>
      </button>
    ));
  }

  rangeSelection = (newOption, index) => {
    if (newOption[index].selected)
      newOption[index].selected = !newOption[index].selected;
    else {
      let selected = 0;
      let lastSelected = 0;
      newOption.map((iOption, idx) => {
        if (iOption.selected) {
          selected++;
          lastSelected = idx;
        }

        return true;
      });

      if (selected === 0)
        newOption[index].selected = !newOption[index].selected;
      else if (selected === 1 || lastSelected < index) {
        let from = lastSelected > index ? index : lastSelected;
        let to = lastSelected > index ? lastSelected : index;
        for (let loopCnt = from; loopCnt <= to; loopCnt++)
          newOption[loopCnt].selected = true;
      } else
        newOption[index].selected = !newOption[index].selected;
    }

    return newOption;
  }

  handleWeightSelect = (index) => {
    let newWeightOption = JSON.parse(JSON.stringify(this.state.weightOption));

    this.setState({
      weightOption: this.rangeSelection(newWeightOption, index)
    });
  }

  handleWeightRangeOnAdd = () => {
    if (this.state.weightFrom === "" || (this.state.weightFrom === "0" && this.state.weightTo === "0") || this.state.weightTo === "" || this.state.weightTo === "0" || this.state.weightToError !== '') {
      return;
    }

    let newSelectedWeight = [];
    this.state.generalSelectedWeight.map((iWeight) => {
      if (iWeight.weightFrom !== this.state.weightFrom || iWeight.weightTo !== this.state.weightTo) {
        newSelectedWeight.push(iWeight);
      }

      return true;
    });
    newSelectedWeight.push({ weightFrom: this.state.weightFrom, weightTo: this.state.weightTo });

    this.setState({
      generalSelectedWeight: newSelectedWeight,
      weightFrom: '',
      weightTo: '',
    });
  }

  updateGeneralWeight = (event) => {
    if (event.key === 'Enter' || event.type === 'blur' || event.key === 'Tab')
      this.handleWeightRangeOnAdd();
  }

  handleCutSelect = (index) => {
    let newCutOption = JSON.parse(JSON.stringify(this.state.cutOption));

    this.setState({
      cutOption: this.rangeSelection(newCutOption, index)
    });
  }

  handlePolSelect = (index) => {
    let newPolOption = JSON.parse(JSON.stringify(this.state.polOption));

    this.setState({
      polOption: this.rangeSelection(newPolOption, index)
    });
  }

  handleSymSelect = (index) => {
    let newSymOption = JSON.parse(JSON.stringify(this.state.symOption));

    this.setState({
      symOption: this.rangeSelection(newSymOption, index)
    });
  }

  handleBlackSelect = (index) => {
    let newBlackOption = JSON.parse(JSON.stringify(this.state.blackOption));

    newBlackOption.map((iBlack, idx) => iBlack.selected = (idx === index) ? !iBlack.selected : false);

    this.setState({
      blackOption: newBlackOption
    });
  }

  handleBGMSelect = (index) => {
    let newBgmOption = JSON.parse(JSON.stringify(this.state.bgmOption));
    newBgmOption.map((iBGM, idx) => iBGM.selected = (idx === index) ? !iBGM.selected : false);

    this.setState({
      bgmOption: newBgmOption
    });
  }

  handleLocationSelect = (index) => {
    let newLocationOption = JSON.parse(JSON.stringify(this.state.locationOption));

    newLocationOption[index].selected = !newLocationOption[index].selected;

    this.setState({
      locationOption: newLocationOption
    });
  }

  handleLabSelect = (index) => {
    let newLabOption = JSON.parse(JSON.stringify(this.state.labOption));

    newLabOption[index].selected = !newLabOption[index].selected;

    this.setState({
      labOption: newLabOption
    });
  }

  handleFloSelect = (index) => {
    let newFloOption = JSON.parse(JSON.stringify(this.state.floOption));

    this.setState({
      floOption: this.rangeSelection(newFloOption, index)
    });
  }

  handleColorSelect = (index) => {
    let newColorOption = JSON.parse(JSON.stringify(this.state.colorOption));

    this.setState({
      colorOption: this.rangeSelection(newColorOption, index)
    });
  }

  handleClaritySelect = (index) => {
    let newClarityOption = JSON.parse(JSON.stringify(this.state.clarityOption));

    this.setState({
      clarityOption: this.rangeSelection(newClarityOption, index)
    });
  }

  handleCPSSelect = (cps, index) => {
    let selection = false;
    let lCutOptions = JSON.parse(JSON.stringify(this.state.cutOption));
    let lPolOptions = JSON.parse(JSON.stringify(this.state.polOption));
    let lSymOptions = JSON.parse(JSON.stringify(this.state.symOption));
    let lCPSOptions = JSON.parse(JSON.stringify(this.state.cpsOption));

    lCPSOptions = lCPSOptions.map((cps) => {
      return cps.selected === lCPSOptions[index].selected ? { ...cps } : { ...cps, selected: false }
    });

    let setReset = !cps.selected;
    lCPSOptions[index].selected = !lCPSOptions[index].selected;

    if (cps.value === 1) //3EX
    {
      selection = true;
      lCutOptions.map((iOption) => {
        if (selection) {
          iOption.selected = setReset;
          if (iOption.label === 'EX')
            selection = false;
        }
        else
          iOption.selected = false;

        return true;
      });

      selection = true;
      lPolOptions.map((iOption) => {
        if (selection) {
          iOption.selected = setReset;
          if (iOption.label === 'EX')
            selection = false;
        }
        else
          iOption.selected = false;

        return true;
      });

      selection = true;
      lSymOptions.map((iOption) => {
        if (selection) {
          iOption.selected = setReset;
          if (iOption.label === 'EX')
            selection = false;
        }
        else
          iOption.selected = false;

        return true;
      });
    } else if (cps.value === 2) //EX Cut
    {
      lCutOptions.map((iOption) => {
        if (iOption.label === 'EX')
          iOption.selected = setReset;
        else
          iOption.selected = false;

        return true;
      });

      selection = true;
      lPolOptions.map((iOption) => {
        if (selection) {
          iOption.selected = setReset;
          if (iOption.label === 'VG')
            selection = false;
        }
        else
          iOption.selected = false;

        return true;
      });

      selection = true;
      lSymOptions.map((iOption) => {
        if (selection) {
          iOption.selected = setReset;
          if (iOption.label === 'VG')
            selection = false;
        }
        else
          iOption.selected = false;

        return true;
      });
    } else if (cps.value === 3) // 3VG+
    {
      lCutOptions.map((iOption) => {
        if (iOption.label === 'EX' || iOption.label === 'VG')
          iOption.selected = setReset;
        else
          iOption.selected = false;

        return true;
      });

      selection = true;
      lPolOptions.map((iOption) => {
        if (selection) {
          iOption.selected = setReset;
          if (iOption.label === 'VG')
            selection = false;
        }
        else
          iOption.selected = false;

        return true;
      });

      selection = true;
      lSymOptions.map((iOption) => {
        if (selection) {
          iOption.selected = setReset;
          if (iOption.label === 'VG')
            selection = false;
        }
        else
          iOption.selected = false;

        return true;
      });
    }

    this.setState({
      cutOption: lCutOptions,
      polOption: lPolOptions,
      symOption: lSymOptions,
      cpsOption: lCPSOptions,
    });
  }

  handleDeleteGeneralWeight = (index) => {
    let newGeneralSelectedWeight = [];
    this.state.generalSelectedWeight.map((iWeight, currIndex) => {
      if (currIndex !== index)
        newGeneralSelectedWeight.push(iWeight);

      return true;
    });

    this.setState({
      generalSelectedWeight: newGeneralSelectedWeight
    });
  }

  clearColorSelection = () => {
    let newColorOption = JSON.parse(JSON.stringify(this.state.colorOption));
    newColorOption.map((iColor) => iColor.selected = false);

    this.setState({
      colorOption: newColorOption,
      selectedFromIntensity: '',
      selectedToIntensity: '',
      selectedOvertone: '',
      selectedFancyColor1: '',
      selectedFancyColor2: '',
    });
  }

  clearWeightSelection = () => {
    let newWeightOption = JSON.parse(JSON.stringify(this.state.weightOption));
    newWeightOption.map((iWeight) => iWeight.selected = false);

    this.setState({
      weightOption: newWeightOption,
      weightFrom: '',
      weightTo: '',
      generalWeightDossiers: false,
      generalWeightCarat: false,
      generalSelectedWeight: [],
    });
  }

  clearSelection = (lOptions) => {
    lOptions.map((iOption) => iOption.selected = false);
  }

  setSelectedValueList = (lFullList, lSelectedList) => {
    let lOption = JSON.parse(JSON.stringify(lFullList));
    lOption.map((iOption) => iOption.selected = (lSelectedList.includes(iOption.value)));

    return lOption;
  }

  setSelectedValueDropdownList = (lFullList, lSelectedList) => {
    let retOption = [];
    lFullList.map((iOption) => {
      if (lSelectedList.includes(iOption.value))
        retOption.push(iOption)

      return true;
    });

    return retOption;
  }

  setSelectedValueDropdownSingle = (lFullList, lSelectedValue) => {
    let retOption = '';
    lFullList.map((iOption) => {
      if (lSelectedValue === iOption.value)
        retOption = iOption;

      return true;
    });

    return retOption;
  }

  handleSaveAs = () => {
    this.setState({
      saveAsLoading: true,
    });

    this.handleSave(this.state.saveAsSearchName)
  }

  handleSave = (iKey) => {
    let lSSC = JSON.parse(JSON.stringify(this.state.savedSearchCriteria));
    let lSSO = JSON.parse(JSON.stringify(this.state.savedSearchOption));
    let foundKey = false;

    let newSelection = this.getSelection();
    lSSC[iKey] = newSelection;
    lSSO.map((iS) => {
      if (iS.value === iKey) {
        iS.searchdata = newSelection
        foundKey = true;
      }

      return true;
    })

    if (!foundKey)
      lSSO.push({ value: iKey, label: iKey, searchdata: newSelection, selected: false });

    StoneProxy.AddStockSearchCriteria(Constants.loggedInUser.id, lSSC, (response) => {
      this.setState({
        savedSearchCriteria: lSSC,
        savedSearchOption: lSSO,
        showSuccessSave: true,
        saveAsLoading: false,
        showSaveAsModal: false,
        saveAsSearchName: ''
      })
    });
  }

  setSelection = (searchdata) => {
    let lCPSOption = JSON.parse(JSON.stringify(this.state.cpsOption));
    lCPSOption.map((iOption) => iOption.selected = false);
    let prevActiveTab = this.state.activeTab;

    this.setState({
      shapeOption: this.setSelectedValueList(this.state.shapeOption, searchdata.shape),
      weightSpecific: searchdata.weightspecific,
      weightOption: this.setSelectedValueList(this.state.weightOption, searchdata.weight),
      weightFrom: searchdata.weightfrom,
      weightTo: searchdata.weightto,
      generalWeightDossiers: searchdata.generalweightdossiers,
      generalWeightCarat: searchdata.generalweightcarat,
      generalSelectedWeight: searchdata.generalselectedweight,
      colorWhite: searchdata.colorwhite,
      colorOption: this.setSelectedValueList(this.state.colorOption, searchdata.color),
      selectedFromIntensity: this.setSelectedValueDropdownSingle(this.state.intensityOption, searchdata.fromintensity),
      selectedToIntensity: this.setSelectedValueDropdownSingle(this.state.intensityOption, searchdata.tointensity),
      selectedOvertone: this.setSelectedValueDropdownList(this.state.overtoneOption, searchdata.overtone),
      selectedFancyColor1: this.setSelectedValueDropdownList(this.state.fancyColorOption, searchdata.fancycolor1),
      selectedFancyColor2: this.setSelectedValueDropdownList(this.state.fancyColorOption, searchdata.fancycolor2),
      clarityOption: this.setSelectedValueList(this.state.clarityOption, searchdata.clarity),
      cpsOption: lCPSOption,
      cutOption: this.setSelectedValueList(this.state.cutOption, searchdata.cut),
      polOption: this.setSelectedValueList(this.state.polOption, searchdata.pol),
      symOption: this.setSelectedValueList(this.state.symOption, searchdata.sym),
      floOption: this.setSelectedValueList(this.state.floOption, searchdata.flo),
      labOption: this.setSelectedValueList(this.state.labOption, searchdata.lab),
      locationOption: this.setSelectedValueList(this.state.locationOption, searchdata.location),
      bgmOption: this.setSelectedValueList(this.state.bgmOption, searchdata.bgm),
      blackOption: this.setSelectedValueList(this.state.blackOption, searchdata.black),
      stonetypeOption: searchdata.stonetype ? this.setSelectedValueList(this.state.stonetypeOption, searchdata.stonetype) : this.state.stonetypeOption,
      activeTab: searchdata.activeTab,
      tabValue: !searchdata.activeTab || searchdata.activeTab === "Natural" ? 0 : (searchdata.activeTab === "Lab Grown" && this.state.showNaturalTab ? 1 : 0),
      depthFrom: searchdata.depthfrom === 0 ? "" : searchdata.depthfrom,
      depthTo: searchdata.depthto === 0 ? "" : searchdata.depthto,
      tableFrom: searchdata.tablefrom === 0 ? "" : searchdata.tablefrom,
      tableTo: searchdata.tableto === 0 ? "" : searchdata.tableto,
      ratioFrom: searchdata.ratiofrom === 0 ? "" : searchdata.ratiofrom,
      ratioTo: searchdata.ratioto === 0 ? "" : searchdata.ratioto,
      lengthFrom: searchdata.lengthfrom === 0 ? "" : searchdata.lengthfrom,
      lengthTo: searchdata.lengthto === 0 ? "" : searchdata.lengthto,
      widthFrom: searchdata.widthfrom === 0 ? "" : searchdata.widthfrom,
      widthTo: searchdata.widthto === 0 ? "" : searchdata.widthto,
      priceFrom: searchdata.pricefrom === 0 ? "" : searchdata.pricefrom,
      priceTo: searchdata.priceto === 0 ? "" : searchdata.priceto,
      totalFrom: searchdata.totalfrom === 0 ? "" : searchdata.totalfrom,
      totalTo: searchdata.totalto === 0 ? "" : searchdata.totalto,
    }, () => {
      if (prevActiveTab !== this.state.activeTab) {
        this.getCustomerData();
      }
    });
  }

  getSelectedValueList = (lOption) => {
    return lOption.filter((iOption) => iOption.selected === true).map((iOption) => iOption.value);
  }

  getSelectedValueDropdownList = (lOption) => {
    if (lOption === '')
      return [];
    return lOption.map((iOption) => iOption.value);
  }

  getSelectedValueDropdownSingle = (lOption) => {
    if (!lOption || lOption === '' || lOption === null)
      return '';
    else
      return lOption.value;
  }

  getSelection = () => {
    // Stonetype
    let tempStoneType;
    if (this.state.activeTab === "Natural" || !this.state.activeTab) {
      tempStoneType = ['N'];
    } else {
      tempStoneType = this.getSelectedValueList(this.state.stonetypeOption);
    }

    return {
      shape: this.getSelectedValueList(this.state.shapeOption),
      weightspecific: this.state.weightSpecific,
      weight: this.getSelectedValueList(this.state.weightOption),
      weightfrom: this.state.weightFrom,
      weightto: this.state.weightTo,
      generalweightdossiers: this.state.generalWeightDossiers,
      generalweightcarat: this.state.generalWeightCarat,
      generalselectedweight: this.state.generalSelectedWeight,
      colorwhite: this.state.colorWhite,
      color: this.getSelectedValueList(this.state.colorOption),
      fromintensity: this.getSelectedValueDropdownSingle(this.state.selectedFromIntensity),
      tointensity: this.getSelectedValueDropdownSingle(this.state.selectedToIntensity),
      overtone: this.getSelectedValueDropdownList(this.state.selectedOvertone),
      fancycolor1: this.getSelectedValueDropdownList(this.state.selectedFancyColor1),
      fancycolor2: this.getSelectedValueDropdownList(this.state.selectedFancyColor2),
      clarity: this.getSelectedValueList(this.state.clarityOption),
      cut: this.getSelectedValueList(this.state.cutOption),
      pol: this.getSelectedValueList(this.state.polOption),
      sym: this.getSelectedValueList(this.state.symOption),
      flo: this.getSelectedValueList(this.state.floOption),
      lab: this.getSelectedValueList(this.state.labOption),
      location: this.getSelectedValueList(this.state.locationOption),
      bgm: this.getSelectedValueList(this.state.bgmOption),
      black: this.getSelectedValueList(this.state.blackOption),
      depthfrom: this.state.depthFrom,
      depthto: this.state.depthTo,
      tablefrom: this.state.tableFrom,
      tableto: this.state.tableTo,
      ratiofrom: this.state.ratioFrom,
      ratioto: this.state.ratioTo,
      lengthfrom: this.state.lengthFrom,
      lengthto: this.state.lengthTo,
      widthfrom: this.state.widthFrom,
      widthto: this.state.widthTo,
      pricefrom: this.state.priceFrom,
      priceto: this.state.priceTo,
      totalfrom: this.state.totalFrom,
      totalto: this.state.totalTo,
      stonetype: tempStoneType,
    }
  }

  resetSelection = () => {
    this.clearWeightSelection();
    this.clearColorSelection();

    let lShapeOption = JSON.parse(JSON.stringify(this.state.shapeOption));
    let lClarityOption = JSON.parse(JSON.stringify(this.state.clarityOption));
    let lCPSOption = JSON.parse(JSON.stringify(this.state.cpsOption));
    let lCutOption = JSON.parse(JSON.stringify(this.state.cutOption));
    let lPolOption = JSON.parse(JSON.stringify(this.state.polOption));
    let lSymOption = JSON.parse(JSON.stringify(this.state.symOption));
    let lFloOption = JSON.parse(JSON.stringify(this.state.floOption));
    let lLabOption = JSON.parse(JSON.stringify(this.state.labOption));
    let lLocationOption = JSON.parse(JSON.stringify(this.state.locationOption));
    let lBGMOption = JSON.parse(JSON.stringify(this.state.bgmOption));
    let lBlackOption = JSON.parse(JSON.stringify(this.state.blackOption));
    let lStoneTypeOption = JSON.parse(JSON.stringify(this.state.stonetypeOption));

    this.clearSelection(lShapeOption);
    this.clearSelection(lClarityOption);
    this.clearSelection(lCPSOption);
    this.clearSelection(lCutOption);
    this.clearSelection(lPolOption);
    this.clearSelection(lSymOption);
    this.clearSelection(lFloOption);
    this.clearSelection(lLabOption);
    this.clearSelection(lLocationOption);
    this.clearSelection(lBGMOption);
    this.clearSelection(lBlackOption);
    this.clearSelection(lStoneTypeOption);

    this.setState({
      selectedCustomer: this.defaultOption,
      stoneIds: '',
      selectedSavedSearch: this.defaultOption,
      selectedPreviousSearch: this.defaultOption,

      shapeOption: lShapeOption,
      clarityOption: lClarityOption,
      cpsOption: lCPSOption,
      cutOption: lCutOption,
      polOption: lPolOption,
      symOption: lSymOption,
      floOption: lFloOption,
      labOption: lLabOption,
      locationOption: lLocationOption,
      bgmOption: lBGMOption,
      blackOption: lBlackOption,
      stonetypeOption: lStoneTypeOption,
      depthFrom: '',
      depthTo: '',
      tableFrom: '',
      tableTo: '',
      ratioFrom: '',
      ratioTo: '',
      lengthFrom: '',
      lengthTo: '',
      widthFrom: '',
      widthTo: '',
      priceFrom: '',
      priceTo: '',
      totalFrom: '',
      totalTo: '',
    });
  }

  drawerClose = () => {
    if (this.props.drawerClose)
      this.props.drawerClose();
  }

  prepareData = () => {
    let searchCriteria = this.getSelection();

    searchCriteria.bgm = searchCriteria.bgm.length > 0 ? searchCriteria.bgm[0] : '';
    searchCriteria.black = searchCriteria.black.length > 0 ? searchCriteria.black[0] : ''

    //Color
    if (searchCriteria.colorwhite) {
      searchCriteria.fancyintensity = [];
      searchCriteria.fancyovertone = [];
      searchCriteria.fancycolor1 = [];
      searchCriteria.fancycolor2 = [];
    } else {
      searchCriteria.color = [];

      searchCriteria.fancyintensity = [];
      let fI = (searchCriteria.fromintensity > searchCriteria.tointensity) ? searchCriteria.tointensity : searchCriteria.fromintensity;
      let tI = (searchCriteria.fromintensity > searchCriteria.tointensity) ? searchCriteria.fromintensity : searchCriteria.tointensity;
      this.state.intensityOption.map((iOpt) => {
        if (iOpt.value >= fI && iOpt.value <= tI)
          searchCriteria.fancyintensity.push(iOpt.label);

        return true;
      });
      searchCriteria.fromintensity = undefined;
      searchCriteria.tointensity = undefined;

      searchCriteria.fancyovertone = this.getIdArrayToStringArray(this.state.overtoneOption, searchCriteria.overtone);
      searchCriteria.overtone = undefined;
    }
    searchCriteria.fancycolor1 = this.getIdArrayToStringArray(this.state.fancyColorOption, searchCriteria.fancycolor1);
    searchCriteria.fancycolor2 = this.getIdArrayToStringArray(this.state.fancyColorOption, searchCriteria.fancycolor2);

    searchCriteria.shape = this.getIdArrayToStringArray(this.state.shapeOption, searchCriteria.shape);

    //Weight - Size
    searchCriteria.sizemasterid = searchCriteria.weight;
    searchCriteria.weight = undefined;

    searchCriteria.generalsize = [];
    searchCriteria.generalselectedweight.map((iW) => searchCriteria.generalsize.push({ sizefrom: iW.weightFrom, sizeto: iW.weightTo }));
    searchCriteria.generalselectedweight = undefined;

    if (searchCriteria.generalweightdossiers === true) {
      searchCriteria.generalsize.push({ sizefrom: "0.00", sizeto: "0.99" });
    }
    searchCriteria.generalweightdossiers = undefined;

    if (searchCriteria.generalweightcarat === true) {
      searchCriteria.generalsize.push({ sizefrom: "1.00", sizeto: "100.00" });
    }
    searchCriteria.generalweightcarat = undefined;
    searchCriteria.weightfrom = undefined;
    searchCriteria.weightto = undefined;
    searchCriteria.weightspecific = undefined;

    //Location
    searchCriteria.locationid = searchCriteria.location;
    searchCriteria.location = undefined;

    searchCriteria.cpricefrom = searchCriteria.pricefrom;
    searchCriteria.pricefrom = undefined;
    searchCriteria.cpriceto = searchCriteria.priceto;
    searchCriteria.priceto = undefined;

    searchCriteria.tpricefrom = searchCriteria.totalfrom;
    searchCriteria.totalfrom = undefined;
    searchCriteria.tpriceto = searchCriteria.totalto;
    searchCriteria.totalto = undefined;

    searchCriteria.reportnumber = this.state.stoneIds;

    this.props.handleSearch(searchCriteria, JSON.stringify(this.state));
    this.props.setFilters(JSON.stringify(this.state));
    this.props.setSelectionModel && this.props.setSelectionModel([]);
    this.drawerClose();
    if (this.props.displaySearchCriteria) this.props.setFlag(false);
  }

  render() {
    return <div style={{ width: "700pt", minHeight: "100%" }}>

      {this.state.showSuccessSave ? (
        <CommonSnackbar
          show={true}
          message={"Search criteria saved Successfully"}
          variant={'success'}
          autoHide={Constants.SnackBarCloseTimer}
          title={"success"}
          handleClose={() => this.setState({ showSuccessSave: false })}
        />
      ) : null}

      {this.state.showUserDetailModal ? (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(1px)",
              zIndex: 1299,
            }}
          />
          <UserDetailModal
            show={true}
            handleClose={() => this.setState({ showUserDetailModal: false })}
            handleSelect={(selectedOption) => {
              const selectedCustomers = this.state.customerOption.filter(opt =>
                selectedOption.includes(opt.value)
              );
              this.setState({ selectedCustomer: selectedCustomers[0], showUserDetailModal: false })
              this.props.setCustomerId(selectedCustomers[0]);
            }}
            userids={this.state.userIds}
            selectedIds={this.state.selectedCustomer.value !== -1 ? [this.state.selectedCustomer.value] : []}
            usertype={"C"}
            loading={this.state.showUserDetailModal}
            isMulti={false}
          />
        </>
      ) : null}

      {this.props.guid && (this.state.selectedCustomer.value === -1 || (Constants.loggedInUser.usertype === "C" && (this.state.selectedCustomer.value !== Constants.loggedInUser.id))) ? (
        <CommonSnackbar
          show={this.state.showCommonSnackbar}
          message={"The customer for which this link is created is not " + (Constants.loggedInUser.usertype === 'C' ? "you." : "connected with you. OR Does not have stonetype permission")}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer + 2000}
          title={"Failed"}
          handleClose={() => { this.setState({ showCommonSnackbar: false }) }}
        />
      ) : null}

      <div style={{ width: "100%", display: "flex", alignItems: "center", padding: "0 10pt", borderBottom: "1px solid lightgray", height: "49px", maxHeight: "49px" }}>

        <div style={{ fontWeight: Constants.defaultFontWeight, fontSize: "20px" }}>Filters</div>

        <Box sx={{
          width: '93%',
          bgcolor: 'background.paper',
          "& .MuiTabs-indicator": {
            height: "3px",
            bottom: "5px"
          },
        }}>
          {this.state.showNaturalTab && this.state.showLabGrownTab ? (
            <Tabs
              value={this.state.tabValue}
              onChange={this.handleTabChange}
              centered
            >
              <Tab label="Natural" />
              <Tab label="Lab Grown" />
            </Tabs>
          ) : null}
        </Box>
        <div style={{ textAlign: "right", cursor: "pointer" }} onClick={(e) => this.drawerClose()}>
          <CloseIcon size="xlarge" />
        </div>
      </div>

      <div style={{ width: "100%", height: "88%", maxHeight: "88%", overflowY: "auto" }}>

        {/* Row 1 */}
        <div style={{ width: "100%", display: "flex" }}>
          {this.props.displaySearchCriteria && (
            <div style={{ width: "30%", padding: "10px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", paddingBottom: "10px" }}>
                <div style={{ fontWeight: Constants.defaultFontWeight }}>Company Name</div>
                {Constants.loggedInUser.usertype !== 'C' && (
                  <>
                    <Tooltip title="View More Data">
                      <span style={{ cursor: "pointer" }}>
                        <OpenInNewIcon
                          style={{ fontSize: '20px', marginBottom: "3px" }}
                          onClick={() => {
                            this.setState({ showUserDetailModal: true });
                          }}
                          color="action"
                        />
                      </span>
                    </Tooltip>
                    {this.state.customerLoadSpinner ? (
                      <CircularProgress size="1rem" />
                    ) : (
                      <Tooltip title="Reload List">
                        <RefreshOutlinedIcon
                          onClick={() => {
                            this.setState({ customerLoadSpinner: true });
                            this.getCustomerData();
                          }}
                          color={"primary"}
                          fontSize="medium"
                          sx={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                    )}
                  </>
                )}
              </div>
              <div>{Constants.loggedInUser.usertype === 'C' ?
                <div style={{ fontWeight: Constants.defaultFontWeight }}>{Constants.loggedInUser.companyname}</div> :
                <table style={{ width: "100%" }}>
                  <tr><td>
                    <Select
                      autosize={false}
                      menuPlacement="auto"
                      blurInputOnSelect={false}
                      value={this.state.selectedCustomer && this.state.selectedCustomer.value !== -1 ?
                        this.state.customerOption.find((iCustomer) =>
                          iCustomer.value === this.state.selectedCustomer.value) :
                        this.state.selectedCustomer}
                      isSearchable={true}
                      isClearable
                      name="Customer"
                      menuPosition="absolute"
                      menuPortalTarget={document.body}
                      styles={{
                        menu: (base) => ({
                          ...base,
                          width: 'auto', // allow it to grow based on content
                          maxWidth: 500, // cap the max width
                          zIndex: 9999, // ensure it overlaps other elements
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      options={this.state.customerOption}
                      onChange={(selectedOption) => {
                        if (selectedOption == null) {
                          this.setState({ selectedCustomer: this.defaultOption });
                        } else {
                          const updatedCustomer = this.updateCustomerLabel(selectedOption);
                          this.props.setCustomerId(updatedCustomer);
                          this.setState({ selectedCustomer: updatedCustomer });
                        }
                      }}
                    />
                  </td></tr>
                </table>
              }</div>
            </div>
          )}

          {this.props.enableReportNoSearchBox && (
            <div style={{ width: "44%", padding: "10px", borderLeft: "1px solid lightgrey", borderRight: "1px solid lightgrey" }}>
              <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Stone Ids or Certificate No (Comma Separated)</div>
              <div>
                <TextField
                  placeholder="Stone Ids or Certificate No (Comma Separated)"
                  multiline
                  size="small"
                  margin="none"
                  rows={1}
                  value={this.state.stoneIds}
                  onChange={(e) => {
                    this.setState({ stoneIds: Utility.ConvertNewLineToComma(e.target.value) })
                  }}
                  style={{
                    width: '24rem',
                    bgcolor: "white",
                    borderColor: "#000",
                    borderWidth: 1,
                    overflowY: "auto"
                  }}
                />
              </div>
            </div>
          )}

          {this.props.showSaveSearchAs && (
            <div style={{ width: "26%" }}>
              <div style={{ width: "100%", padding: "10px", display: "flex", flexDirection: "row" }}>
                <div style={{ fontWeight: Constants.defaultFontWeight, flex: "1", whiteSpace: "nowrap" }}>Search &nbsp;&nbsp;
                  <span onClick={() => {
                    this.setState({ savedSearch: true });

                    if (this.state.selectedSavedSearch.value !== -1)
                      this.handleSavedSearchChange(this.state.selectedSavedSearch);
                  }} style={{ fontSize: 10, color: this.state.savedSearch ? 'black' : 'GrayText', cursor: "pointer" }}>Saved </span>
                  |
                  <span onClick={() => {
                    this.setState({ savedSearch: false });
                    this.getPreviousSearchData();
                    if (this.state.selectedPreviousSearch.value !== -1) {
                      this.handlePreviousSearchChange(this.state.selectedPreviousSearch);
                    }
                  }} style={{ fontSize: 10, color: !this.state.savedSearch ? 'black' : 'GrayText', cursor: "pointer", }}> Previous</span>
                </div>
                {
                  this.state.savedSearch &&
                  <div style={{ float: "right", fontSize: 10, textAlign: "right" }}>
                    {
                      this.state.selectedSavedSearch.value !== -1 ?
                        <span style={{ cursor: "pointer" }} onClick={(e) => this.handleSave(this.state.selectedSavedSearch.value)}><SaveIcon fontSize='small' />&nbsp;Save</span>
                        :
                        (
                          !this.state.showSaveAsModal ?
                            <span style={{ cursor: "pointer" }} onClick={(e) => this.setState({ showSaveAsModal: true })}><SaveAsIcon fontSize='small' />&nbsp;Save As</span>
                            :
                            <div style={{ width: "100%", float: "right" }}><input placeholder="Save search key" label="Save search key"
                              size="small"
                              margin="none"
                              value={this.state.saveAsSearchName}
                              onChange={(e) => this.setState({ saveAsSearchName: e.target.value })}
                              style={{
                                width: "60%",
                                bgcolor: "white",
                                borderColor: "#000",
                                borderWidth: 1,
                              }}
                            />
                              <CheckIcon fontSize='small' color={"success"} onClick={() => { if (this.state.saveAsSearchName.trim() !== '') this.handleSaveAs() }} />
                              <CloseIcon fontSize='small' color={"warning"} onClick={() => this.setState({ showSaveAsModal: false })} />
                            </div>
                        )
                    }
                  </div>
                }
              </div>
              {this.state.savedSearch ? (
                <div style={{ width: "100%", padding: "0 10px", display: "block" }}>
                  <Select
                    autosize={false}
                    menuPlacement="auto"
                    blurInputOnSelect={false}
                    value={this.state.selectedSavedSearch.value !== -1 ? this.state.savedSearchOption.find(
                      (iSavedSearch) =>
                        iSavedSearch.value === this.state.selectedSavedSearch.value
                    ) : this.state.selectedSavedSearch}
                    isClearable
                    isSearchable={true}
                    name="Saved Search"
                    sx={{ width: 'inherit' }}
                    options={this.state.savedSearchOption}
                    onChange={(selectedOption) => {
                      if (selectedOption === null) {
                        this.resetSelection();
                      } else {
                        this.handleSavedSearchChange(selectedOption);
                      }
                    }}
                  />
                </div>
              ) : (
                <div style={{ width: "100%", padding: "0 10px", display: "block" }}>
                  <Select
                    autosize={false}
                    menuPlacement="auto"
                    blurInputOnSelect={false}
                    value={this.state.selectedPreviousSearch.value !== -1 ? this.state.previousSearchOption.find(
                      (iPrevSearch) =>
                        iPrevSearch.value === this.state.selectedPreviousSearch.value
                    ) : this.state.selectedPreviousSearch}
                    isSearchable={true}
                    isClearable
                    name="PreviousSearch"
                    sx={{ width: 'inherit' }}
                    options={this.state.previousSearchOption}
                    onChange={(selectedOption) => {
                      if (selectedOption === null) {
                        this.resetSelection();
                      } else {
                        this.handlePreviousSearchChange(selectedOption);
                      }
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </div>

        {/* Row 2 */}
        <div style={{ width: "100%", padding: "10px", borderTop: "1px solid lightgray" }}>
          <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Shape</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(11, 1fr)", gap: "8px 8px" }}>
            {this.getShapeIcons()}
          </div>
          {
            this.state.showMoreShapeOption ?
              this.state.showAllShape ?
                <div onClick={() => this.setState({ showAllShape: false })} style={{ fontSize: 11, fontWeight: 'bold', cursor: "pointer", textAlign: "center", paddingTop: "10px" }}>Fewer shapes <ExpandLessIcon /></div>
                :
                <div onClick={() => this.setState({ showAllShape: true })} style={{ fontSize: 11, fontWeight: 'bold', cursor: "pointer", textAlign: "center", paddingTop: "10px" }}>More shapes <ExpandMoreIcon /></div>
              :
              <div />
          }
        </div>

        {/* Row 3 */}
        <div style={{ width: "100%", padding: "10px", borderTop: "1px solid lightgray" }}>
          <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Carat (ct) &nbsp;&nbsp;
            {/* Below general and specific are actually specific and general in database and everywhere else. Only UI shows general and specific. */}
            <span onClick={() => this.setState({ weightSpecific: true })} style={{ fontSize: 10, color: this.state.weightSpecific ? 'black' : 'GrayText', cursor: "pointer" }}>GENERAL </span>
            |
            <span onClick={() => this.setState({ weightSpecific: false })} style={{ fontSize: 10, color: !this.state.weightSpecific ? 'black' : 'GrayText', cursor: "pointer", }}> SPECIFIC</span>
            <div style={{ textAlign: "right", cursor: "pointer", float: "right", padding: "10pt", display: "inline-table", fontSize: 10 }} onClick={(e) => this.clearWeightSelection()}>Clear &nbsp; X</div>
          </div>
          <div>
            {this.state.weightSpecific && (
              <div>
                {this.state.weightOption.map((iWeight, index) => (
                  <>
                    {/* {iWeight.label === "1ct" ? <br /> : null} */}
                    <button onClick={() => this.handleWeightSelect(index)} style={{ borderRadius: 4, margin: 2, minWidth: '45px', height: '35px', alignItems: 'center', backgroundColor: iWeight.selected ? "#DDE2EE" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }} >
                      <div>
                        <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{iWeight.label}</p>
                      </div>
                    </button>
                  </>
                ))}
              </div >
            )}
            {!this.state.weightSpecific && (
              <Box
                display={"flex"}
                alignItems={"center"}
                gap={"5px"}
              >
                <TextField
                  margin="normal"
                  size="small"
                  id="From"
                  type={"number"}
                  label="From"
                  sx={{ bgcolor: "white", width: '100px' }}
                  value={this.state.weightFrom}
                  onChange={(event) => {
                    if (event.target.value === '') {
                      this.setState({
                        weightFrom: '',
                        weightToError: ''
                      });
                      return;
                    }

                    let tValue = Utility.CheckisNumberPositive(event.target.value);
                    if (tValue) {
                      let weightToError = this.state.weightToError;

                      if (this.state.weightTo !== "") {
                        const isValid = Utility.IsToGreaterThanFrom(event.target.value, this.state.weightTo);
                        weightToError = isValid ? '' : `Value must be greater than or equal to ${event.target.value}`;
                      }
                      this.setState({
                        weightFrom: event.target.value.trim(),
                        weightToError,
                      });
                    } else {
                      this.setState({ weightFrom: '', weightToError: '' });
                    }
                  }}
                  onKeyDown={this.updateGeneralWeight}
                  onBlur={this.updateGeneralWeight}
                  InputLabelProps={{
                    shrink: (this.state.weightFrom !== ""),
                  }}
                />
                <Tooltip
                  title={this.state.weightToError}
                  open={Boolean(this.state.weightToError)}
                  placement="bottom-end"
                  arrow
                >
                  <TextField
                    margin="normal"
                    size="small"
                    id="To"
                    type={"number"}
                    label="To"
                    sx={{ bgcolor: "white", width: '100px' }}
                    value={this.state.weightTo}
                    error={Boolean(this.state.weightToError)}
                    onChange={(event) => {
                      if (event.target.value === '') {
                        this.setState({
                          weightTo: '', weightToError: ''
                        });
                        return;
                      }

                      let tValue = Utility.CheckisNumberPositive(event.target.value);
                      if (tValue) {
                        const { weightFrom } = this.state;
                        const isValid = Utility.IsToGreaterThanFrom(this.state.weightFrom, event.target.value);

                        this.setState({
                          weightTo: event.target.value.trim(),
                          weightToError: weightFrom === "" || isValid ? '' : `Value must be greater than or equal to ${weightFrom}`,
                        });
                      } else {
                        this.setState({ weightTo: '', weightToError: '' });
                      }
                    }}
                    onKeyDown={this.updateGeneralWeight}
                    onBlur={this.updateGeneralWeight}
                    InputLabelProps={{
                      shrink: (this.state.weightTo !== ""),
                    }}
                  />
                </Tooltip>
                <AddCircleOutlineIcon fontSize="medium" sx={{ cursor: "pointer", marginTop: "8px" }} onClick={() => this.handleWeightRangeOnAdd()} />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.generalWeightDossiers}
                      onChange={() => this.setState({ generalWeightDossiers: !this.state.generalWeightDossiers })}
                    />
                  }
                  label="DOSSIERS"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: "0.8rem",
                      fontWeight: Constants.defaultFontWeight,
                      alignItems: 'center',
                    },
                  }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.generalWeightCarat}
                      onChange={() => this.setState({ generalWeightCarat: !this.state.generalWeightCarat })}
                    />
                  }
                  label="CARAT+"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: "0.8rem",
                      fontWeight: Constants.defaultFontWeight,
                      alignItems: 'center',
                    },
                  }}
                />

                <Box>
                  {this.state.generalSelectedWeight.map((iWeightRange, index) => (
                    <button style={{
                      borderRadius: 4, margin: 2, minWidth: '70px', height: '35px', alignItems: 'center', flexDirection: 'row',
                      backgroundColor: "#DDE2EE",
                      border: 1, borderStyle: 'solid', borderColor: '#ececec',
                      color: "#000", whiteSpace: 'nowrap'
                    }}>
                      <span style={{ fontSize: 11, fontWeight: 'bold' }}>{iWeightRange.weightFrom} - {iWeightRange.weightTo}</span>
                      <DeleteIcon fontSize="small" color="#000" sx={{ marginLeft: 2 }} onClick={() => this.handleDeleteGeneralWeight(index)} />
                    </button>
                  ))}
                </Box>
              </Box>
            )}
          </div>
        </div>

        {/* Row 4 */}
        <div style={{ display: "flex", borderTop: "1px solid lightgray" }}>
          <div style={{ width: "65%", padding: "10px", borderRight: "1px solid lightgray" }}>
            <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Color &nbsp;&nbsp;
              <span onClick={() => this.setState({ colorWhite: true })} style={{ fontSize: 10, color: this.state.colorWhite ? 'black' : 'GrayText', cursor: "pointer" }}>WHITE </span>
              |
              <span onClick={() => this.setState({ colorWhite: false })} style={{ fontSize: 10, color: !this.state.colorWhite ? 'black' : 'GrayText', cursor: "pointer", }}> FANCY</span>
              <div style={{ textAlign: "right", cursor: "pointer", float: "right", padding: "10pt", display: "inline-table", fontSize: 10 }} onClick={(e) => this.clearColorSelection()}>Clear &nbsp; X</div>
            </div>
            <div>
              {this.state.colorWhite ? (
                <div>
                  {this.state.colorOption.map((color, index) => (
                    <button onClick={() => this.handleColorSelect(index)} style={{ borderRadius: 4, margin: 2, minWidth: '40px', height: '35px', alignItems: 'center', backgroundColor: color.selected ? "#DDE2EE" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }} >
                      <div>
                        <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{color.label}</p>
                      </div>
                    </button>
                  ))}
                </div>
              ) :
                (
                  <Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={"5px"}>
                    <Box style={{ display: 'flex', flexDirection: 'row', gap: '10px', width: '100%' }}>
                      <Box style={{ width: '25%', alignSelf: 'flex-end' }}>
                        <span style={{ fontSize: 10, fontWeight: "bold" }}>
                          INTENSITY
                        </span>
                        <Select menuPlacement="auto"
                          blurInputOnSelect={false}
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="From"
                          value={this.state.selectedFromIntensity}
                          name="From"
                          menuPortalTarget={document.body}
                          styles={Constants.Styles}
                          options={this.state.intensityOption}
                          onChange={(selectedOption) =>
                            this.setState({ selectedFromIntensity: selectedOption })
                          }
                        />
                      </Box>
                      <Box style={{ width: '25%', alignSelf: 'flex-end' }}>
                        <Select menuPlacement="auto"
                          blurInputOnSelect={false}
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="To"
                          value={this.state.selectedToIntensity}
                          name="To"
                          menuPortalTarget={document.body}
                          styles={Constants.Styles}
                          options={this.state.intensityOption}
                          onChange={(selectedOption) =>
                            this.setState({ selectedToIntensity: selectedOption })
                          }
                        />
                      </Box>
                      <Box style={{ width: '50%' }}>
                        <span style={{ fontSize: 10, fontWeight: "bold" }}>
                          OVERTONE
                        </span>
                        <Select menuPlacement="auto"
                          blurInputOnSelect={false}
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="overtone"
                          value={this.state.selectedOvertone}
                          isSearchable={true}
                          name="OVERTONE"
                          isMulti
                          menuPortalTarget={document.body}
                          styles={Constants.Styles}
                          options={this.state.overtoneOption}
                          onChange={(selectedOption) =>
                            this.setState({ selectedOvertone: selectedOption })
                          }
                        />
                      </Box>
                    </Box>
                    <Box style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: '10px' }}>
                      <Box style={{ width: '52%' }}>
                        <span style={{ fontSize: 10, fontWeight: "bold" }}>
                          FANCY COLOR 1
                        </span>
                        <Select menuPlacement="auto"
                          blurInputOnSelect={false}
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="fancy color 1"
                          value={this.state.selectedFancyColor1}
                          isSearchable={true}
                          name="FANCY COLOR 1"
                          isMulti
                          menuPortalTarget={document.body}
                          styles={Constants.Styles}
                          options={this.state.fancyColorOption}
                          onChange={(selectedOption) => this.setState({ selectedFancyColor1: selectedOption })}
                        />
                      </Box>
                      <Box style={{ width: '50%' }}>
                        <span style={{ fontSize: 10, fontWeight: "bold" }}>
                          FANCY COLOR 2
                        </span>
                        <Select menuPlacement="auto"
                          blurInputOnSelect={false}
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="fancy color 2"
                          value={this.state.selectedFancyColor2}
                          isSearchable={true}
                          name="FANCY COLOR 2"
                          isMulti
                          menuPortalTarget={document.body}
                          styles={Constants.Styles}
                          options={this.state.fancyColorOption}
                          onChange={(selectedOption) => this.setState({ selectedFancyColor2: selectedOption })}
                        />
                      </Box>
                    </Box>
                  </Box>
                )}
            </div>
          </div>
          <div style={{ width: "35%", padding: "10px" }}>
            <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Clarity</div>
            <div>
              {this.state.clarityOption.map((clarity, index) => (
                <button onClick={() => this.handleClaritySelect(index)} style={{ borderRadius: 4, margin: 2, minWidth: '40px', maxWidth: '40px', height: '35px', alignItems: 'center', backgroundColor: clarity.selected ? "#DDE2EE" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }} >
                  <div>
                    <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{clarity.label}</p>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Row 5 */}
        <div style={{ borderTop: "1px solid lightgray" }}>
          <div style={{ width: "100%", padding: "10px", display: "flex", alignItems: "center", gap: "20px" }}>
            <div style={{ fontWeight: Constants.defaultFontWeight }}>Cut, polish & Symmetry</div>
            <div>
              {this.state.cpsOption.map((cps, index) => (
                <button onClick={() => this.handleCPSSelect(cps, index)} style={{ borderRadius: 4, margin: 2, minWidth: '50px', maxWidth: '40px', height: '35px', alignItems: 'center', backgroundColor: cps.selected ? "#DDE2EE" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }} >
                  <div>
                    <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{cps.label}</p>
                  </div>
                </button>
              ))}
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ width: "36%", padding: "0 10px 10px" }}>
              <div style={{ paddingBottom: "10px", fontSize: "12px" }}>Cut</div>
              <div>
                {this.state.cutOption.map((cut, index) => (
                  <button onClick={() => this.handleCutSelect(index)} style={{ borderRadius: 4, margin: 2, minWidth: '40px', maxWidth: '40px', height: '35px', alignItems: 'center', backgroundColor: cut.selected ? "#DDE2EE" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }} >
                    <div>
                      <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{cut.label}</p>
                    </div>
                  </button>
                ))}
              </div>
            </div>
            <div style={{ width: "33%", padding: "0 10px 10px", borderLeft: "1px solid lightgray", borderRight: "1px solid lightgray" }}>
              <div style={{ paddingBottom: "10px", fontSize: "12px" }}>Polish</div>
              <div>
                {this.state.polOption.map((pol, index) => (
                  <button onClick={() => this.handlePolSelect(index)} style={{ borderRadius: 4, margin: 2, minWidth: '40px', maxWidth: '40px', height: '35px', alignItems: 'center', backgroundColor: pol.selected ? "#DDE2EE" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }} >
                    <div>
                      <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{pol.label}</p>
                    </div>
                  </button>
                ))}
              </div>
            </div>
            <div style={{ width: "31%", padding: "0 10px 10px" }}>
              <div style={{ paddingBottom: "10px", fontSize: "12px" }}>Symmetry</div>
              <div>
                {this.state.symOption.map((sym, index) => (
                  <button onClick={() => this.handleSymSelect(index)} style={{ borderRadius: 4, margin: 2, minWidth: '40px', maxWidth: '40px', height: '35px', alignItems: 'center', backgroundColor: sym.selected ? "#DDE2EE" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }} >
                    <div>
                      <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{sym.label}</p>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Row 6 */}
        <div style={{ display: "flex", borderTop: "1px solid lightgray" }}>
          <div style={{ width: "40%", padding: "10px" }}>
            <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Fluorescent</div>
            <div>
              {this.state.floOption.map((flo, index) => (
                <button onClick={() => this.handleFloSelect(index)} style={{ borderRadius: 4, margin: 2, minWidth: '40px', height: '35px', alignItems: 'center', backgroundColor: flo.selected ? "#DDE2EE" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }} >
                  <div>
                    <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{flo.label}</p>
                  </div>
                </button>
              ))}
            </div>
          </div>
          <div style={{ width: "20%", padding: "10px", borderLeft: "1px solid lightgray", borderRight: "1px solid lightgray" }}>
            <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Lab</div>
            <div>
              {this.state.labOption.map((lab, index) => (
                <button onClick={() => this.handleLabSelect(index)} style={{ borderRadius: 4, margin: 2, minWidth: '40px', height: '35px', alignItems: 'center', backgroundColor: lab.selected ? "#DDE2EE" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }} >
                  <div>
                    <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{lab.label}</p>
                  </div>
                </button>
              ))}
            </div>
          </div>
          <div style={{ width: "40%", padding: "10px" }}>
            <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Location</div>
            <div>
              {this.state.locationOption.map((location, index) => (
                <button onClick={() => this.handleLocationSelect(index)} style={{ borderRadius: 4, margin: 2, minWidth: '40px', height: '35px', alignItems: 'center', backgroundColor: location.selected ? "#DDE2EE" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }} >
                  <div>
                    <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{location.label}</p>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Row 7 */}
        {this.state.activeTab === "Lab Grown" ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              p: this.state.showAdvanceOption ? "10px" : "10px 10px 0 10px",
              borderTop: "1px solid lightgray"
            }}
          >
            <Box>
              <div style={{ fontWeight: Constants.defaultFontWeight }}>Treatment Type : </div>
            </Box>
            <Box
              sx={{
                alignSelf: "center",
                width: "70%",
              }}
            >
              <div>
                {this.state.stonetypeOption.map((stonetype, index) => (
                  <button onClick={() => {
                    let tempStoneTypeOption = this.state.stonetypeOption.map((istonetype, sindex) => {
                      if (sindex === index)
                        istonetype.selected = !istonetype.selected;

                      return istonetype;
                    });
                    this.setState({ stonetypeOption: tempStoneTypeOption });
                  }} style={{ borderRadius: 4, marginRight: "8px", minWidth: '40px', height: '2rem', alignItems: 'center', backgroundColor: stonetype.selected ? "#DDE2EE" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }} >
                    <div>
                      <p style={{ fontSize: 12, fontWeight: 'bold', marginBottom: '0rem' }}>{stonetype.label}</p>
                    </div>
                  </button>
                ))}
              </div>
            </Box>
          </Box>
        ) : null}

        {/* Advanced Option */}
        {!this.state.showAdvanceOption &&
          (<div
            style={{ fontSize: 11, fontWeight: 'bold', cursor: "pointer", textAlign: "center", padding: "10px 0" }}
            onClick={() => this.setState({ showAdvanceOption: true })}
          >
            Show advance options <ExpandMoreIcon />
          </div>)}

        {/* Row 8 */}
        {this.state.showAdvanceOption &&
          (<div style={{ display: "flex", borderTop: "1px solid lightgray" }}>
            <div style={{ width: "36%", padding: "10px" }}>
              <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>BGM</div>
              <div>
                {this.state.bgmOption.map((bgm, index) => (
                  <button onClick={() => this.handleBGMSelect(index)} style={{ borderRadius: 4, margin: 2, minWidth: '40px', height: '35px', alignItems: 'center', backgroundColor: bgm.selected ? "#DDE2EE" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }} >
                    <div>
                      <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{bgm.label}</p>
                    </div>
                  </button>
                ))}
              </div>
            </div>
            <div style={{ width: "33%", padding: "10px", borderLeft: "1px solid lightgray", borderRight: "1px solid lightgray" }}>
              <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Black</div>
              <div>
                {this.state.blackOption.map((black, index) => (
                  <button onClick={() => this.handleBlackSelect(index)} style={{ borderRadius: 4, margin: 2, minWidth: '40px', height: '35px', alignItems: 'center', backgroundColor: black.selected ? "#DDE2EE" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }} >
                    <div>
                      <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{black.label}</p>
                    </div>
                  </button>
                ))}
              </div>
            </div>
            <div style={{ width: "31%", padding: "10px" }}>
              <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Depth</div>
              <div>
                <input
                  placeholder="From" label="From" size="small" margin="none" value={this.state.depthFrom}
                  onChange={(e) => {
                    const newFrom = e.target.value;
                    const { depthTo } = this.state;
                    let error = '';
                    if (depthTo && newFrom !== "" && !Utility.IsToGreaterThanFrom(newFrom, depthTo)) {
                      error = `Value must be greater than or equal to ${newFrom}`;
                    }
                    this.setState({ depthFrom: newFrom, depthFromToError: error });
                  }}
                  style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                />
                &nbsp;-&nbsp;
                <Tooltip
                  title={this.state.depthFromToError}
                  open={Boolean(this.state.depthFromToError)}
                  placement="bottom-end"
                  arrow
                >
                  <input
                    placeholder="To" label="To" size="small" margin="none" value={this.state.depthTo}
                    onChange={(e) => {
                      const newTo = e.target.value;
                      const { depthFrom } = this.state;
                      let error = '';
                      if (depthFrom && newTo !== "" && !Utility.IsToGreaterThanFrom(depthFrom, newTo)) {
                        error = `Value must be greater than or equal to ${depthFrom}`;
                      }
                      this.setState({ depthTo: newTo, depthFromToError: error });
                    }}
                    style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                  />
                </Tooltip>
              </div>
            </div>
          </div>)}

        {/* Row 9 */}
        {this.state.showAdvanceOption &&
          (<div style={{ display: "flex", borderTop: "1px solid lightgray" }}>
            <div style={{ width: "36%", padding: "10px" }}>
              <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Table</div>
              <div>
                <input
                  placeholder="From" label="From" size="small" margin="none" value={this.state.tableFrom}
                  onChange={(e) => {
                    const newFrom = e.target.value;
                    let error = '';
                    if (this.state.tableTo && newFrom !== "" && !Utility.IsToGreaterThanFrom(newFrom, this.state.tableTo)) {
                      error = `Value must be greater than or equal to ${newFrom}`;
                    }
                    this.setState({ tableFrom: newFrom, tableFromToError: error });
                  }}
                  style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                />&nbsp;-&nbsp;
                <Tooltip
                  title={this.state.tableFromToError}
                  open={Boolean(this.state.tableFromToError)}
                  placement="bottom-end"
                  arrow
                >
                  <input
                    placeholder="To" label="To" size="small" margin="none" value={this.state.tableTo}
                    onChange={(e) => {
                      const newTo = e.target.value;
                      const { tableFrom } = this.state;
                      let error = '';
                      if (tableFrom && newTo !== "" && !Utility.IsToGreaterThanFrom(tableFrom, newTo)) {
                        error = `Value must be greater than or equal to ${tableFrom}`;
                      }
                      this.setState({ tableTo: newTo, tableFromToError: error });
                    }}
                    style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                  />
                </Tooltip>
              </div>
            </div>
            <div style={{ width: "33%", padding: "10px", borderLeft: "1px solid lightgray", borderRight: "1px solid lightgray" }}>
              <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Ratio</div>
              <div>
                <input
                  placeholder="From" label="From" size="small" margin="none" value={this.state.ratioFrom}
                  onChange={(e) => {
                    const newFrom = e.target.value;
                    let error = '';
                    if (this.state.ratioTo && newFrom !== "" && !Utility.IsToGreaterThanFrom(newFrom, this.state.ratioTo)) {
                      error = `Value must be greater than or equal to ${newFrom}`;
                    }
                    this.setState({ ratioFrom: newFrom, ratioFromToError: error });
                  }}
                  style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                />&nbsp;-&nbsp;
                <Tooltip
                  title={this.state.ratioFromToError}
                  open={Boolean(this.state.ratioFromToError)}
                  placement="bottom-end"
                  arrow
                >
                  <input
                    placeholder="To" label="To" size="small" margin="none" value={this.state.ratioTo}
                    onChange={(e) => {
                      const newTo = e.target.value;
                      const { ratioFrom } = this.state;
                      let error = '';
                      if (ratioFrom && newTo !== "" && !Utility.IsToGreaterThanFrom(ratioFrom, newTo)) {
                        error = `Value must be greater than or equal to ${ratioFrom}`;
                      }
                      this.setState({ ratioTo: newTo, ratioFromToError: error });
                    }}
                    style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                  />
                </Tooltip>
              </div>
            </div>
            <div style={{ width: "31%", padding: "10px" }}>
              <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Length</div>
              <div>
                <input
                  placeholder="From" label="From" size="small" margin="none" value={this.state.lengthFrom}
                  onChange={(e) => {
                    const newFrom = e.target.value;
                    let error = '';
                    if (this.state.lengthTo && newFrom !== "" && !Utility.IsToGreaterThanFrom(newFrom, this.state.lengthTo)) {
                      error = `Value must be greater than or equal to ${newFrom}`;
                    }
                    this.setState({ lengthFrom: newFrom, lengthFromToError: error });
                  }}
                  style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                />&nbsp;-&nbsp;
                <Tooltip
                  title={this.state.lengthFromToError}
                  open={Boolean(this.state.lengthFromToError)}
                  placement="bottom-end"
                  arrow
                >
                  <input
                    placeholder="To" label="To" size="small" margin="none" value={this.state.lengthTo}
                    onChange={(e) => {
                      const newTo = e.target.value;
                      const { lengthFrom } = this.state;
                      let error = '';
                      if (lengthFrom && newTo !== "" && !Utility.IsToGreaterThanFrom(lengthFrom, newTo)) {
                        error = `Value must be greater than or equal to ${lengthFrom}`;
                      }
                      this.setState({ lengthTo: newTo, lengthFromToError: error });
                    }}
                    style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                  />
                </Tooltip>
              </div>
            </div>
          </div>)}

        {/* Row 10 */}
        {this.state.showAdvanceOption &&
          (<div style={{ display: "flex", borderTop: "1px solid lightgray" }}>
            <div style={{ width: "36%", padding: "10px" }}>
              <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>Width</div>
              <div>
                <input
                  placeholder="From" label="From" size="small" margin="none" value={this.state.widthFrom}
                  onChange={(e) => {
                    const newFrom = e.target.value;
                    let error = '';
                    if (this.state.widthTo && newFrom !== "" && !Utility.IsToGreaterThanFrom(newFrom, this.state.widthTo)) {
                      error = `Value must be greater than or equal to ${newFrom}`;
                    }
                    this.setState({ widthFrom: newFrom, widthFromToError: error });
                  }}
                  style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                />&nbsp;-&nbsp;
                <Tooltip
                  title={this.state.widthFromToError}
                  open={Boolean(this.state.widthFromToError)}
                  placement="bottom-end"
                  arrow
                >
                  <input
                    placeholder="To" label="To" size="small" margin="none" value={this.state.widthTo}
                    onChange={(e) => {
                      const newTo = e.target.value;
                      const { widthFrom } = this.state;
                      let error = '';
                      if (widthFrom && newTo !== "" && !Utility.IsToGreaterThanFrom(widthFrom, newTo)) {
                        error = `Value must be greater than or equal to ${widthFrom}`;
                      }
                      this.setState({ widthTo: newTo, widthFromToError: error });
                    }}
                    style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                  />
                </Tooltip>
              </div>
            </div>
            <div style={{ width: "33%", padding: "10px", borderLeft: "1px solid lightgray", borderRight: "1px solid lightgray" }}>
              <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>$/CT</div>
              <div>
                <input
                  placeholder="From" label="From" size="small" margin="none" value={this.state.priceFrom}
                  onChange={(e) => {
                    const newFrom = e.target.value;
                    let error = '';
                    if (this.state.priceTo && newFrom !== "" && !Utility.IsToGreaterThanFrom(newFrom, this.state.priceTo)) {
                      error = `Value must be greater than or equal to ${newFrom}`;
                    }
                    this.setState({ priceFrom: newFrom, priceFromToError: error });
                  }}
                  style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                />&nbsp;-&nbsp;
                <Tooltip
                  title={this.state.priceFromToError}
                  open={Boolean(this.state.priceFromToError)}
                  placement="bottom-end"
                  arrow
                >
                  <input
                    placeholder="To" label="To" size="small" margin="none" value={this.state.priceTo}
                    onChange={(e) => {
                      const newTo = e.target.value;
                      const { priceFrom } = this.state;
                      let error = '';
                      if (priceFrom && newTo !== "" && !Utility.IsToGreaterThanFrom(priceFrom, newTo)) {
                        error = `Value must be greater than or equal to ${priceFrom}`;
                      }
                      this.setState({ priceTo: newTo, priceFromToError: error });
                    }}

                    style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                  />
                </Tooltip>
              </div>
            </div>
            <div style={{ width: "31%", padding: "10px" }}>
              <div style={{ fontWeight: Constants.defaultFontWeight, paddingBottom: "10px" }}>$/Total</div>
              <div>
                <input
                  placeholder="From" label="From" size="small" margin="none" value={this.state.totalFrom}
                  onChange={(e) => {
                    const newFrom = e.target.value;
                    let error = '';
                    if (this.state.totalTo && newFrom !== "" && !Utility.IsToGreaterThanFrom(newFrom, this.state.totalTo)) {
                      error = `Value must be greater than or equal to ${newFrom}`;
                    }
                    this.setState({ totalFrom: newFrom, totalFromToError: error });
                  }}
                  style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                />&nbsp;-&nbsp;
                <Tooltip
                  title={this.state.totalFromToError}
                  open={Boolean(this.state.totalFromToError)}
                  placement="bottom-end"
                  arrow
                >
                  <input
                    placeholder="To" label="To" size="small" margin="none" value={this.state.totalTo}
                    onChange={(e) => {
                      const newTo = e.target.value;
                      const { totalFrom } = this.state;
                      let error = '';
                      if (totalFrom && newTo !== "" && !Utility.IsToGreaterThanFrom(totalFrom, newTo)) {
                        error = `Value must be greater than or equal to ${totalFrom}`;
                      }
                      this.setState({ totalTo: newTo, totalFromToError: error });
                    }}
                    style={{ width: '40%', bgcolor: "white", padding: 7, borderColor: "#000", borderWidth: 2 }}
                  />
                </Tooltip>
              </div>
            </div>
          </div>)}

        {this.state.showAdvanceOption && (
          <div
            style={{
              fontSize: 11,
              fontWeight: 'bold',
              cursor: 'pointer',
              textAlign: 'center',
              padding: '10px 0',
            }}
            onClick={() => this.setState({ showAdvanceOption: false })}
          >
            Hide advance options <ExpandLessIcon />
          </div>
        )}
      </div>

      {this.props.readOnly === false ? (
        <div style={{ width: "100%", textAlign: "right", paddingTop: "10px", borderTop: "1px solid lightgray" }}>
          <Button
            variant="outlined"
            size="small"
            style={{
              color: "#454545",
              height: "40px",
            }}
            sx={{ ml: "5px", color: '#DDE2EE' }}
            onClick={() => this.resetSelection()}
          >
            Reset
          </Button>&nbsp;
          <Button
            variant="outlined"
            size="small"
            style={{
              color: "#454545",
              height: "40px",
            }}
            sx={{ ml: "5px", color: '#DDE2EE' }}
            endIcon={<CloseIcon size="xlarge" />}
            onClick={() => this.drawerClose()}
          >
            Cancel
          </Button>&nbsp;
          <Button
            variant="contained"
            size="small"
            color="inherit"
            sx={{ ml: "5px", height: "40px", backgroundColor: '#454545', color: 'white', '&:hover': { backgroundColor: '#454545' } }}
            onClick={(e) => {
              if (this.state.activeTab === "Lab Grown" && this.getSelectedValueList(this.state.stonetypeOption).length === 0) {
                let tempStoneTypeOption = this.state.stonetypeOption.map(istonetype => {
                  istonetype.selected = true;
                  return istonetype;
                })

                //As discussed with mitesh bhai, whatever typed in from to size is also getting applied for search criteria 5/2/25
                this.handleWeightRangeOnAdd();

                this.setState({ stonetypeOption: tempStoneTypeOption }, () => {
                  // This callback ensures prepareData is called after state has been updated
                  this.prepareData();
                });
              } else {
                // If no state change is needed, call prepareData directly
                this.prepareData();
              }
            }}
            endIcon={<CheckIcon size="xlarge" />}
            disabled={(Constants.loggedInUser.usertype !== 'C' && this.state.selectedCustomer.value === -1 && this.props.displaySearchCriteria === true)}
          >
            Apply Filters
          </Button>
          &nbsp;&nbsp;
        </div>
      ) : ("")}
    </div>;
  }
}